import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../state'
import { updateLevel } from '../../../state/market/actions'

// components
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import ModalTitle from '../../../components/bakery/ModalTitle'
import useModal from '../../../hooks/bakery/useModal'
import RevokeAllModal from './RevokeAllModal'

const Version = styled.div`
  text-align: center;
  margin-top: 20px;
  z-index: 1;
`
const Content = styled.div`
  display:flex;
  justify-content: space-between;
  align-items: center;
  width: 355px;
  margin: auto;
  z-index: 1;
`
const Item = styled.div`
  width: 148px;
`
const ItemTitle = styled.div`
  display: flex;
  align-items: baseline;
  color: #A54819;
`
const Num = styled.div`
  font-family: Baloo Da;
  font-style: normal;
  font-weight: normal;
  font-size: 48px;
`
const Label = styled.div`
  font-family: Baloo Da;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
`
const ItemText = styled.div`
  font-family: Yuanti SC;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #AC562A;
  margin-top: -10px;
  margin-bottom: 20px;
`
const ItemBtn = styled.div`
  background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
  border-radius: 10px;
  font-family: Baloo Da;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height */
  text-align: center;
  /* #FFF3E0 */
  color: #FFF3E0;
  width: 148px;
  height: 38px;
  line-height: 38px;
  text-align:center;
  cursor: pointer;
`
// const ItemBtn2 = styled(ItemBtn)`
//   background: linear-gradient(339.37deg, #FFD600 -29.29%, #FF7A00 86.19%);
//   opacity: 0.4;
// `

const UpgradeBg = styled.div`
  position: absolute;
  left: -32px;
  bottom: -44px;
`

interface UpgradeModalProps extends ModalProps {
}

const UpgradeModal: React.FC<UpgradeModalProps> = ({
  onDismiss
}) => {
  const [onPresentExchange] = useModal(
    <RevokeAllModal/>
  )

  const revokeAll = () => {
    onDismiss && onDismiss()
    onPresentExchange()
  }

const dispatch = useDispatch<AppDispatch>()


  const goV3 = () => {
    dispatch(updateLevel({level: 'v3'}))
    onDismiss && onDismiss()
  }

  return (
    <Modal maxWidth={480} backgroundColor={'#FFF3E0'}>
      <ModalTitle text={'Upgrade your NFT Marketplace'} />
      <Version>
        <img src="/images/nft/v123.svg" />
      </Version>
      <Content>
        <Item>
          <ItemTitle>
            <Num>1</Num>
            <Label>Revoke</Label>
          </ItemTitle>
          <ItemText>Revoke your Artworks from V1&V2</ItemText>
          <ItemBtn onClick={() => {revokeAll()}}>Revoke All</ItemBtn>
        </Item>
        <Item>
          <ItemTitle>
            <Num>2</Num>
            <Label>Go to V3</Label>
          </ItemTitle>
          <ItemText>Go to V3 to start your new NFT travel!</ItemText>
          <ItemBtn onClick={() => {goV3()}}>Go to V3</ItemBtn>
        </Item>
      </Content>
      <UpgradeBg>
        <img src="/images/nft/upgradeBg.svg" />
      </UpgradeBg>
    </Modal>
  )
}

export default UpgradeModal
